import * as React from 'react';
import type { Router } from 'react-router';
import { IndexRedirect, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import TeamsApp from 'bundles/teams-v2/components/TeamsApp';

const AccountDetails = loadOnRoute(() => import('bundles/teams-v2/components/AccountDetails/AccountDetails'));
const BillingInfo = loadOnRoute(() => import('bundles/teams-v2/components/BillingInfo/BillingInfo'));
const PurchaseConfirmation = loadOnRoute(
  () => import('bundles/teams-v2/components/PurchaseConfirmation/PurchaseConfirmation')
);
const InvoiceConfirmation = loadOnRoute(() => import('bundles/teams-v2/components/InvoiceConfirmation'));

const requireRedirect: Router.EnterHook = (nextState, replace) => {
  const currentQuery = nextState.location.query || {};

  // if not learnerCount, make it 5
  if (!currentQuery.learnerCount) {
    currentQuery.learnerCount = 5;
  }

  // if not billingType, make it 1
  if (!currentQuery.billingType) {
    currentQuery.billingType = 1;
  }

  if (currentQuery && 'thirdPartyOrganizationId' in currentQuery) {
    currentQuery.thirdPartyOrganizationId = currentQuery.thirdPartyOrganizationId;
    replace({
      pathname: '/purchase/billing',
      query: currentQuery,
    });
    return;
  }

  replace({
    pathname: '/purchase/account',
    query: currentQuery,
  });
};

export default (
  <Route path="/">
    <Route path="purchase" component={TeamsApp}>
      <Route path="plan" onEnter={requireRedirect} />
      <Route path="account" getComponent={AccountDetails} />
      <Route path="billing" getComponent={BillingInfo} />
      <Route path="invoice-confirmation" getComponent={InvoiceConfirmation} />
      <Route path="confirmation" getComponent={PurchaseConfirmation} />
      <Route path="*" component={NotFound} />
      <IndexRedirect to="/purchase/plan" />
    </Route>
  </Route>
);
